import { ACTION_STATUSES, ACTION_TYPES } from 'Data/actions';

const initialState = {
  isFetchingMeetingState: false,
  meetingState: void 0,
  isEndingMeeting: false,
  isCreatingMeeting: false,
  isJoiningMeeting: false,
  chimeMeeting: null,
  chimeAttendee: null,
  dataBridgeCode: null,
  dataBridgeShowError: false,
  isFetchingPatientContactDetails: false,
  patientContactDetails: null,
};

export default (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ACTION_TYPES.STORE_RESET:
      return initialState;
    case ACTION_TYPES.MEETING_JOIN:
      switch (action.status) {
        case ACTION_STATUSES.REQUEST.status:
          return {
            ...state,
            isJoiningMeeting: true,
          };
        case ACTION_STATUSES.FAIL.status:
          return {
            ...state,
            isJoiningMeeting: false,
            chimeMeeting: null,
            chimeAttendee: null,
          };
        case ACTION_STATUSES.SUCCESS.status:
          if (action.payload) {
            return {
              ...state,
              isJoiningMeeting: false,
              chimeMeeting: action.payload.meeting,
              chimeAttendee: action.payload.attendee,
            };
          }
          return state;
        default:
          return state;
      }
    case ACTION_TYPES.MEETING_CREATE:
      switch (action.status) {
        case ACTION_STATUSES.REQUEST.status:
          return {
            ...state,
            isCreatingMeeting: true,
          };
        case ACTION_STATUSES.FAIL.status:
          return {
            ...state,
            isCreatingMeeting: false,
            chimeMeeting: null,
            chimeAttendee: null,
          };
        case ACTION_STATUSES.SUCCESS.status:
          if (action.payload) {
            return {
              ...state,
              isCreatingMeeting: false,
              chimeMeeting: action.payload.meeting,
              chimeAttendee: action.payload.attendee,
            };
          }
          return state;
        default:
          return state;
      }
    case ACTION_TYPES.MEETING_END:
      switch (action.status) {
        case ACTION_STATUSES.REQUEST.status:
          return {
            ...state,
            isEndingMeeting: true,
          };
        case ACTION_STATUSES.FAIL.status:
          return {
            ...state,
            isEndingMeeting: false,
          };
        case ACTION_STATUSES.SUCCESS.status:
          return {
            ...state,
            isEndingMeeting: false,
            chimeMeeting: null,
            chimeAttendee: null,
          };
        default:
          return state;
      }
    case ACTION_TYPES.MEETING_GET_INFO:
      switch (action.status) {
        case ACTION_STATUSES.REQUEST.status:
          return {
            ...state,
            isFetchingMeetingState: true,
          };
        case ACTION_STATUSES.FAIL.status:
          return {
            ...state,
            isFetchingMeetingState: false,
          };
        case ACTION_STATUSES.SUCCESS.status:
          if (action.payload) {
            return {
              ...state,
              isFetchingMeetingState: false,
              meetingState: action.payload,
            };
          }
          return state;
        default:
          return state;
      }
    case ACTION_TYPES.INCOMING_PATIENT_CONTACT_PARAMETERS:
      switch (action.status) {
        case ACTION_STATUSES.SUCCESS.status:
          if (action.payload) {
            return {
              ...state,
              patientContactParameters: action.payload,
            };
          }
          return state;
        default:
          return state;
      }
    case ACTION_TYPES.MEETING_STORE_PATIENT_CODE: {
      if (action.payload.code) {
        return {
          ...state,
          dataBridgeCode: action.payload.code,
          dataBridgeShowError: action.payload.showError,
        };
      }
      return {
        ...state,
        dataBridgeShowError: action.payload.showError,
      };
    }
    case ACTION_TYPES.MEETING_PUT_PATIENT_DETAILS:
      switch (action.status) {
        case ACTION_STATUSES.REQUEST.status:
          return {
            ...state,
            isFetchingPatientContactDetails: true,
          };
        case ACTION_STATUSES.FAIL.status:
          return {
            ...state,
            isFetchingPatientContactDetails: false,
          };
        case ACTION_STATUSES.SUCCESS.status:
          if (action.payload) {
            return {
              ...state,
              isFetchingPatientContactDetails: false,
              patientContactDetails: action.payload,
              dataBridgeCode: null,
              dataBridgeShowError: null,
            };
          }
          return state;
        default:
          return state;
      }
    default:
      return state;
  }
};
